import { render } from "./ComingSoonView.vue?vue&type=template&id=2ecac90a&scoped=true"
import script from "./ComingSoonView.vue?vue&type=script&lang=js"
export * from "./ComingSoonView.vue?vue&type=script&lang=js"

import "./ComingSoonView.vue?vue&type=style&index=0&id=2ecac90a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecac90a"]])

export default __exports__